import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import PlanetLinks from '../../../components/PlanetLinks/PlanetLinks';
import './Eclipse.scss';

const Eclipse = () => {
  const [year, setYear] = useState(2025);
  const [eclipseData, setEclipseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // fetch eclipses from API
  useEffect(() => {
    const fetchEclipses = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(
          `https://core-c343.onrender.com/api/eclipes?year=${year}`
        );
        setEclipseData(res.data?.months || []);
      } catch (err) {
        setError('Failed to fetch eclipse data');
      } finally {
        setLoading(false);
      }
    };

    fetchEclipses();
  }, [year]);

  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };

  return (
    <div className="Eclipse-container">
      <InnerNav />
      <div className="Eclipse-content">
        <Zodiac />

        {/* Eclipse Calendar JSX starts here */}
        <div className="eclipse-wrapper">
          <div className="eclipse-header dark">
            <div className="highlight">
              <h2>{year} Eclipse Dates</h2>

              {/* Controls */}
              <div className="eclipse-controls">
                <input
                  type="number"
                  value={year}
                  onChange={handleYearInput}
                />
                <button onClick={() => changeYear(-1)}>Prev Year</button>
                <button onClick={() => setYear(new Date().getFullYear())}>
                  Current Year
                </button>
                <button onClick={() => changeYear(1)}>Next Year</button>
              </div>
            </div>
          </div>

          {loading && <p className="loading-text">Loading eclipses...</p>}
          {error && <p className="error-text">{error}</p>}

          <div className="eclipse-list">
            {eclipseData.map((item, index) => (
              <div className="eclipse-item" key={index}>
                <img
                  src="https://images.unsplash.com/photo-1529788295308-1eace6f67388?fm=jpg&q=60&w=3000"
                  alt="Eclipse"
                  className="eclipse-image"
                />

                <div className="eclipse-details">
                  <p className="eclipse-date">{item.date}</p>
                  <p className="eclipse-weekday">{item.weekday}</p>
                  <p className="eclipse-name">{item.description}</p>
                  <p className="eclipse-type">{item.astronomicalEvent}</p>
                  {item.visibilityNote && (
                    <p className="eclipse-visibility">{item.visibilityNote}</p>
                  )}
                </div>

                <div className="eclipse-icon-section">
                  <span className="eclipse-kind">{item.eclipseType}</span>
                  <div
                    className={`eclipse-icon ${
                      item.eclipseType.includes('Solar')
                        ? 'surya'
                        : 'chandra'
                    }`}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Eclipse Calendar JSX ends here */}

        <PlanetLinks />
      </div>
      <Footer />
    </div>
  );
};

export default Eclipse;
